class CartRemoveItem extends HTMLElement {
  constructor() {
    super();
    this.querySelector('a').addEventListener('click', (event) => {
      event.preventDefault();
      const cartItems = this.closest('cart-items');
      // Remove-button übergibt 0 – updateQuantity parst daraus ohnehin eine Integer 0
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }
}
customElements.define('cart-remove-item-button', CartRemoveItem);

class CartItemsUpdate extends HTMLElement {
  constructor() {
    super();
    const debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, ON_CHANGE_DEBOUNCE_TIMER);
    this.addEventListener('change', debouncedOnChange.bind(this));
  }

  cartUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
      if (event.source === 'cart-items') return;
      this.onCartUpdate();
    });
  }

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    // Aus dem Input-Feld kommt immer ein String – wir wandeln ihn sofort in eine Integer um:
    const rawValue = event.target.value;
    const parsed = parseInt(rawValue, 10);
    const qty = Number.isNaN(parsed) ? 0 : parsed;

    this.updateQuantity(
      event.target.dataset.index,
      qty,
      document.activeElement.getAttribute('name')
    );
  }

  onCartUpdate() {
    const section = this.tagName === 'CART-ITEMS' ? 'mini-cart' : 'main-cart';
    const url = `${routes.cart_url}?section_id=${section}`;
    fetch(url)
      .then((r) => r.text())
      .then((htmlText) => {
        const html = new DOMParser().parseFromString(htmlText, 'text/html');
        if (section === 'mini-cart') {
          const source = html.querySelector('cart-items');
          const target = document.querySelector('cart-items');
          if (source && target) target.replaceWith(source);
        } else {
          const sourceItems = html.querySelector('cart-items');
          if (sourceItems) {
            this.innerHTML = sourceItems.innerHTML;
            cartfootertab();
          }
        }
        if (document.querySelector("#cart-upsell-product")) {
          themeSlidersInit($("#cart-upsell-product"));
        }
      })
      .catch((e) => console.error(e));
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: document.getElementById('mini-cart')?.id,
        selector: 'mini-cart'
      },
      {
        id: 'main-cart',
        section: document.getElementById('main-cart')?.dataset.id,
        selector: '.cart-content'
      },
      {
        id: 'main-cart-summary',
        section: document.getElementById('main-cart-summary')?.dataset.id,
        selector: '.js-contents'
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    // 2. Schutz: falls quantity doch kein Integer ist, parsen wir hier
    const maybeParsed = Number.isInteger(quantity)
      ? quantity
      : parseInt(quantity, 10);
    const qty = Number.isNaN(maybeParsed) ? 0 : maybeParsed;

    const body = JSON.stringify({
      line,
      quantity: qty,
      sections: this.getSectionsToRender().map(s => s.section),
      sections_url: window.location.pathname,
    });

    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body
    })
      .then((response) => response.text())
      .then((state) => {
        const resultState = JSON.parse(state);
        const quantityElement =
          document.getElementById(`Quantity-${line}`) ||
          document.getElementById(`Drawer-Quantity-${line}`);

        if (resultState.errors) {
          quantityElement.value = quantityElement.getAttribute('value');
          this.updateLiveRegions(line, resultState.errors);
          return;
        }

        this.getSectionsToRender().forEach((section) => {
          const el = document.getElementById(section.id)
                        .querySelector(section.selector) ||
                     document.getElementById(section.id);

          el.innerHTML = this.getSectionInnerHTML(
            resultState.sections[section.section],
            section.selector
          );

          const totalCount = resultState.item_count;
          const drawerCount = document.querySelector("#cartDrawer-count");
          if (drawerCount) drawerCount.textContent = `(${totalCount})`;

          const headerCount = document.querySelector("[data-header-cart-count]");
          if (headerCount) {
            headerCount.classList.toggle("hidden", totalCount === 0);
            if (totalCount > 0 && totalCount < 100) {
              headerCount.textContent = totalCount;
            } else {
              headerCount.textContent = '';
            }
          }

          if (document.querySelector("#cart-upsell-product")) {
            themeSlidersInit($("#cart-upsell-product"));
          }
          shippingProgressBar(resultState.total_price);
        });

        cartfootertab();
        this.updateLiveRegions(line, /* hier ggf. eine Erfolgsmeldung */ '');
      })
      .catch(() => {
        this.querySelectorAll('.loading-overlay')
            .forEach(o => o.classList.add('hidden'));
      });
  }

  updateLiveRegions(line, message) {
    const errEl =
      document.getElementById(`Line-item-error-${line}`) ||
      document.getElementById(`CartDrawer-Line-item-error-${line}`);
    if (errEl) {
      errEl.querySelector('.cart-item-error').innerHTML = message;
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector)
      .innerHTML;
  }
}
customElements.define('cart-items', CartItemsUpdate);

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.contentItems = this.querySelectorAll(".cart-tools-wrapper");
        this.addEventListener(
          'change',
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(), body
            });
          }, ON_CHANGE_DEBOUNCE_TIMER)
        );
      }
    }
  );
}

class CartFooterContent extends HTMLElement {
  constructor() {
    super();
    this.dataItems = this.querySelectorAll('[data-details-item]');
    this.dataItemsContents = this.querySelectorAll(".cart-tools-wrapper");

    Array.from(this.dataItems).forEach((el, idx) => {
      if (
        idx === 0 &&
        el.closest("li") &&
        !el.closest("mini-cart")
      ) {
        el.closest("li").classList.add("active");
        document.querySelector(el.getAttribute("href"))
                .classList.add("active");
      }
    });

    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('[data-details-item]')
        .forEach(el => el.addEventListener('click', this.changeItems.bind(this)));
    this.querySelectorAll('[data-close-details]')
        .forEach(el => el.addEventListener('click', this.closeItems.bind(this)));
  }

  changeItems(event) {
    event.preventDefault();
    const target = event.currentTarget;
    const head = target.getAttribute("href");

    this.dataItems.forEach(di => di.closest("li").classList.remove("active"));
    target.closest("li").classList.add("active");

    this.dataItemsContents.forEach(dc => dc.classList.remove("active"));
    this.querySelector(head).classList.toggle("active");
  }

  closeItems(event) {
    event.preventDefault();
    this.querySelector("li.active")?.classList.remove("active");
    event.currentTarget.closest(".cart-tools-wrapper")
                 .classList.remove("active");
  }
}
customElements.define('cart-footer-content', CartFooterContent);

class ShippingCalculator extends HTMLElement {
  constructor() {
    super();
    this.setupCountries();
    this.zip = this.querySelector('#shippingZip');
    this.country = this.querySelector('#shippingCountry');
    this.province = this.querySelector('#shippingProvince');
    this.button = this.querySelector('button');
    this.errors = this.querySelector('#shippingErrors');
    this.success = this.querySelector('#shippingResponse');
    this.button.addEventListener('click', this.onSubmitHandler.bind(this));
  }

  setupCountries() {
    if (Shopify && Shopify.CountryProvinceSelector) {
      new Shopify.CountryProvinceSelector(
        'shippingCountry',
        'shippingProvince',
        { hideElement: 'shipping-province' }
      );
    }
  }

  onSubmitHandler(event) {
    event.preventDefault();
    this.errors.classList.add('hidden');
    this.success.classList.add('hidden');
    [this.zip, this.country, this.province].forEach(el =>
      el.classList.remove('invalid')
    );
    this.button.classList.add('loading');
    this.button.disabled = true;

    const body = JSON.stringify({
      shipping_address: {
        zip: this.zip.value,
        country: this.country.value,
        province: this.province.value
      }
    });
    let url = `${window.routes.cart_url}/shipping_rates.json`.replace('//','/');

    fetch(url, { ...fetchConfig('javascript'), body })
      .then(r => r.json())
      .then(result => {
        if (result.shipping_rates) {
          if (result.shipping_rates.length) {
            this.success.classList.remove('hidden');
            this.success.innerHTML = '';
            result.shipping_rates.forEach(rate => {
              const p = document.createElement('p');
              p.textContent = `${rate.name}: ${rate.price} ${Shopify.currency.active}`;
              this.success.appendChild(p);
            });
          } else {
            this.errors.classList.remove('hidden');
            this.errors.querySelector('.errors')
                .textContent = 'Cart shipping rates not available';
          }
        } else {
          const msgs = [];
          Object.entries(result).forEach(([attr, msgsArr]) => {
            msgs.push(`${attr.charAt(0).toUpperCase() + attr.slice(1)} ${msgsArr[0]}`);
          });
          this.errors.classList.remove('hidden');
          this.errors.querySelector('.errors').innerHTML = msgs.join('; ');
        }
      })
      .catch(e => console.error(e))
      .finally(() => {
        this.button.classList.remove('loading');
        this.button.disabled = false;
      });
  }
}
customElements.define('shipping-calculator', ShippingCalculator);
